module.exports = __webpack_public_path__ + "images/user_graph.gif";